import * as React from 'react';
import { IComment, IMeta } from 'models/common';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { CoverPicture } from 'components/Profile/CoverPicture';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import { PortalInputField } from '.';
import ReviewScoreSetter from './ReviewScoreSetter';
import { Button, WhiteButton } from 'components';
import { addUserReview } from 'redux/modules/user/usercard';

export interface IReviewBox {
	reviewbox: {
		text: string;
		score: number;
	};
}

interface IProps extends ReturnType<typeof mapStateToProps> {
	shopId?: string;
	usage?: 'portal' | 'admin';
	input?: any;
	label?: any;
	rows?: number;
	meta?: IMeta;
	autoFocus?: any;
	readOnly?: boolean;
	placeholder?: string;
	description?: string;
	onChangeAction?: any;
	addReview?: (review: IComment) => any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	reset?: () => void;

	/* functions props */
	t?: (key: string) => string;
	handleSave?: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ReviewBoxForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.hasValue = this.hasValue.bind(this);
	}

	public onSubmit(form: IReviewBox) {
		console.error('not implemented', form);
	}

	public handleClose() {
		if (this.props.reset) {
			this.props.reset();
		}
	}
	public handleSave() {
		if (this.props.reset) {
			this.props.reset();
		}
		if (this.props.addReview) {
			// TODO currently API returns error (Invalid shopID!)
			// Needs testing once shops can leave reviews to users
			const review: IComment = {
				rating: this.props.currentFormValues.reviewbox.score,
				body: this.props.currentFormValues.reviewbox.text,
				addedByEmail: this.props.userProfileData.email,
				addedById: this.props.userProfileData.id,
				parentId: this.props.userCardData.usercard.id,
			};
			this.props.addReview(review);
		}
	}
	public hasValue(): boolean {
		if (
			this.props.currentFormValues &&
			(this.props.currentFormValues.reviewbox.text || this.props.currentFormValues.reviewbox.score)
		) {
			return true;
		}
		return false;
	}

	public render() {
		const { t, handleSubmit, reviewBoxError, currentFormValues, shopId } = this.props;

		return shopId ? (
			<form
				onSubmit={handleSubmit(this.onSubmit)}
				className="review-box d-flex flex-row align-items-start flex-wrap"
				autoComplete="off"
			>
				<div className="photo-container d-flex align-items-center justify-content-center">
					<CoverPicture imageUrl={''} editFunction={null} />
				</div>
				<div className={`field-container ${this.hasValue() ? 'value' : ''}`}>
					<Field
						name="reviewbox.text"
						component={PortalInputField}
						type="text"
						label={t('User_UserCard_WriteAReview')}
					></Field>
					<Field name="reviewbox.score" component={ReviewScoreSetter} />
				</div>
				{reviewBoxError?.error?.length && !currentFormValues?.reviewbox?.text ? (
					<p className="p14 red error">{reviewBoxError.error[0]}</p>
				) : null}
				<div className="buttons-container d-flex flex-row justify-content-end">
					<WhiteButton onClick={this.handleClose} size="small">
						{t('BSPortal_Common_Cancel')}
					</WhiteButton>
					<Button onClick={this.handleSave} size="small" type="submit">
						{t('User_UserCard_SubmitReview')}
					</Button>
				</div>
			</form>
		) : null;
	}
}

function mapStateToProps(state: IStore) {
	const userCardData = state.usercard;
	const userProfileData = state.userprofile.user;
	let currentFormValues: IReviewBox = null;
	if (state.form[c.FORM_NAME_REVIEWBOX] && state.form[c.FORM_NAME_REVIEWBOX].values) {
		currentFormValues = state.form[c.FORM_NAME_REVIEWBOX].values;
	}
	return {
		userCardData,
		userProfileData,
		currentFormValues,
		reviewBoxError: state.usercard.reviewBoxError,
		formErrors: getFormSyncErrors(c.FORM_NAME_REVIEWBOX)(state),
	};
}

let ReviewBox = reduxForm({
	form: c.FORM_NAME_REVIEWBOX,
})(ReviewBoxForm);

ReviewBox = connect(mapStateToProps, (dispatch) => ({
	addReview: (review: IComment) => dispatch(addUserReview(review)),
}))(ReviewBox);

export default ReviewBox;
